import {useState} from 'react';

export type SortDir = 'asc' | 'desc';

/**
 * Column-sort state + toggle, with no sorting of its own. The server-paged roster lists map this to
 * a Mandark `sort` param; the client-side co-teacher list pairs it with an in-memory sort
 * (see useClientSort). Clicking the active column flips direction; a new column starts ascending.
 */
export const useSortState = (initialKey: string, initialDir: SortDir = 'asc') => {
  const [sortKey, setSortKey] = useState(initialKey);
  const [sortDir, setSortDir] = useState<SortDir>(initialDir);

  const toggleSort = (key: string) => {
    if (key === sortKey) {
      setSortDir((dir) => (dir === 'asc' ? 'desc' : 'asc'));
      return;
    }
    setSortKey(key);
    setSortDir('asc');
  };

  return {sortKey, sortDir, toggleSort};
};
